<template>
  <MainTemplate>
    <back-link text="Мастера" link="/masters"/>
    <div class="mobile__wrap">
      <row margin="0 -15px">
        <grid-item xs="12" xl="8" mb="15px">
          <white-bg style="min-height: 400px" :padding="isMobile ? '20px' : '30px'">
            <preload-content :loading="!master" min-height="400px">
              <div v-if="master">
                <div class="flex__top">
                  <BigImageWithRate v-if="master.avatar" :src="master.avatar" :rate="master.rate"/>
                  <info-page-block>
                    <h1 class=" infoPage">{{ master.full_name }}</h1>
                    <row margin="0 -10px 10px -10px" v-if="master.specializations">
                      <tag v-for="specialization in master.specializations" :key="specialization.id">{{ specialization.name }}</tag>
                    </row>
                    <template v-if="master.coworkings.length">
                      <address-component mb="10px" v-for="coworking in master.coworkings" :key="coworking.id">
                        <span v-if="coworking.city">г. {{ coworking.city.name }},</span>
                        {{ coworking.address }}
                      </address-component>
                    </template>
                    <div v-if="prices && Object.keys(prices).length">
                      <flex justify="between" mb="15px" mt="25px">
                        <h3 class="infoPage-subtitle">Услуги и цены</h3>
                        <button class="specbtn" @click="isOpenedServicesModal = true">Смотреть все</button>
                      </flex>
                      <price-list :prices="prices"/>
                    </div>

                    <div style="display: flex;flex-wrap: wrap;justify-content: space-between" v-if="!getUser || isClient">
                      <button-component
                          v-if="false"
                          size="big"
                          variant="filled"
                          :width="canCall ? '49%' : '100%'"
                          mt="30px"
                          @click="writeToMaster"
                      >
                        Написать {{ canCall ? '' : 'мастеру' }}
                      </button-component>
                      <button-component
                          size="big"
                          variant="filled"
                          width="49%"
                          mt="30px"
                          @click="callToMaster"
                          v-if="canCall && false"
                      >
                        Позвонить
                      </button-component>


                      <div style="display: flex;margin-top: 20px; align-items: center">
                        <strong>Связаться с мастером: </strong>
                        <a v-if="master.call" :href="`tel:${master.phone}`" style="margin-left: 20px">
                          <img src="/phone.png" height="25px">
                        </a>
                        <a v-if="master.whatsapp" :href="`whatsapp://send?phone=${master.phone}`" style="margin-left: 20px">
                          <img src="/whatsapp.png" height="25px">
                        </a>
                        <a v-if="master.viber" :href="`viber://chat?number=${master.phone}`" style="margin-left: 20px">
                          <img src="/viber.png" height="25px">
                        </a>
                        <a v-if="master.telegram" :href="`tg://resolve?domain=${master.telegram}`" style="margin-left: 20px">
                          <img src="/telegram.png" height="25px">
                        </a>
                      </div>
                    </div>
                  </info-page-block>
                </div>
              </div>
            </preload-content>
            <preload-content :loading="!portfolio" :min-height="!portfolio ? '400px' : ''">
              <div v-if="hasTabs">
                <h3>Портфолио</h3>
                <flex justify="between">
                  <tabs :tabs="tabs" @changeTab="(tab) => selectedTab = tab"/>
                  <carousel-buttons
                      :prev-button="goToPrevSlide"
                      :next-button="goToNextSlide"
                      v-if="!isMobile"
                  />
                </flex>

                <div class="carouselWrap">
                  <carousel ref="carousel" :options="options">
                    <portfolio-image v-for="item in tabPortfolio" :key="item.id" :src="item.path"/>
                  </carousel>
                </div>
              </div>
            </preload-content>
          </white-bg>
        </grid-item>
        <grid-item xs="12" xl="4">
          <preload-content :loading="!reviews" min-height="360px">
            <Reviews v-if="reviews"
                     :reviews="reviews"
                     :page="reviewsPage"
                     :last-page="reviewsLastPage"
                     :total="reviewsTotal"
                     :show-destroy="showDestroyReview"
                     @more="moreReviews"
                     @destroy="destroyReview"
            />
          </preload-content>
        </grid-item>
      </row>
    </div>
    <MasterModal
        v-if="prices && Object.keys(prices).length"
        :is-open="isOpenedServicesModal"
        :close="() => isOpenedServicesModal = false"
        :data="prices"
    >
    </MasterModal>
  </MainTemplate>
</template>

<script>
import preloadContent from '../../components/ui/preload-content';
import PriceList from './MasterComponents/PriceList';

import MainTemplate from '../../templates/MainTemplate'
import BackLink from '../../components/ui/back-link'
import Row from '../../components/grid/Row'
import GridItem from '../../components/grid/GridItem'
import Reviews from '../../components/Reviews'
import WhiteBg from '../../components/ui/white-bg'
import Flex from '../../components/ui/flex'
import Tag from '../../components/ui/text/tag'
import AddressComponent from '../../components/ui/text/address-component'
import ButtonComponent from '../../components/ui/buttons/button-component'
import InfoPageBlock from '../../components/ui/card/info-page-block'
import Tabs from '../../components/functional/Tabs'
import BigImageWithRate from '../../components/ui/bigImageWithRate'
import CarouselButtons from '../../components/ui/buttons/carouselButtons'
import PortfolioImage from '../../components/ui/portfolio/portfolio-image'
import {VueAgile} from 'vue-agile'
import MasterModal from './MasterComponents/MasterModal'
import ChatMixin from '@/mixins/chat'
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'Master',
  mixins: [
    ChatMixin
  ],
  components: {
    MasterModal,
    PortfolioImage,
    CarouselButtons,
    BigImageWithRate,
    Tabs,
    InfoPageBlock,
    ButtonComponent,
    AddressComponent,
    Tag,
    WhiteBg,
    Reviews,
    BackLink,
    MainTemplate,
    Row,
    GridItem,
    Flex,
    preloadContent,
    carousel: VueAgile,
    PriceList,
  },
  computed: {
    ...mapGetters(['isUserAuth', 'isClient', 'getUser']),
    canCall() {
      return this.master && this.master.can_call_me && this.master.phone;
    },
    tabs() {
      if (!this.specializations || !this.portfolio) return false;
      return this.specializations.filter((val) => {
        return !!this.portfolio.filter((workplace) => workplace.specialization_id === val.id).length;
      }).map((val, index) => {
        val.isActive = index === this.selectedTab;
        return val;
      });
    },
    tabPortfolio() {
      if (!this.tabs || !this.tabs[this.selectedTab] || !this.portfolio.length) return [];
      return this.portfolio.filter((portfolio) => portfolio.specialization_id === this.tabs[this.selectedTab].id);
    },
    hasTabs() {
      return this.tabs && !!this.tabs.length;
    },
    isMobile() {
      return document.documentElement.clientWidth < 991
    }
  },
  data: () => ({
    selectedTab: 0,

    master: null,
    prices: null,
    portfolio: null,
    specializations: null,

    reviews: null,
    reviewsPage: 1,
    reviewsLastPage: 1,
    reviewsTotal: 0,

    isOpenedServicesModal: false,

    options: {
      infinite: false,
      navButtons: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }
        },

        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    }
  }),
  mounted() {
    this.loadMaster();
    this.loadPrices();
    this.loadReviews();
    this.loadPortfolio();
    this.$eventHub.$on('review.create', this.createReview);
  },
  methods: {
    ...mapMutations(['openModal', 'closeModals']),
    /** load info methods */
    loadReviews() {
      return this.$api.master.review.list(this.$route.params.id, this.reviewsPage).then((data) => {
        this.reviews = data.data;
        this.reviewsTotal = data.meta.total;
        this.reviewsLastPage = data.meta.last_page;
      });
    },
    loadMaster() {
      return this.$api.master.item(this.$route.params.id).then((data) => {
        this.master = data.data;
        this.specializations = this.master.specializations;
      });
    },
    loadPrices() {
      return this.$api.master.price.list(this.$route.params.id).then((data) => this.prices = data.data);
    },
    loadPortfolio() {
      return this.$api.master.portfolio.list(this.$route.params.id).then((data) => this.portfolio = data.data);
    },
    /** tab methods */
    createTab(specialization) {
      return {
        isActive: false,
        name: specialization.name,
        specialization_id: specialization.id
      }
    },
    /** reviews methods*/
    moreReviews() {
      this.reviewsPage += 1;
      return this.$api.master.review.list(this.$route.params.id, this.reviewsPage).then((data) => this.reviews.push(...data.data));
    },
    createReview(data) {
      this.$api.master.review.create(this.$route.params.id, data)
          .then(() => {
            this.reviews = null;
            this.reviewsPage = 1;
            this.reviewsLastPage = null;
            this.loadReviews();
            this.closeModals();
            this.$toast.success('Отзыв успешно добавлен!');
          }).catch(({response}) => {
        if (response.data.errors) this.$eventHub.$emit('review.create.error', response.data.errors);
      })
    },
    showDestroyReview(review) {
      return review.user_id == (this.getUser ? this.getUser.id : -1);
    },
    destroyReview(review) {
      this.$api.master.review.destroy(this.$route.params.id, review.id).then(() => {
        this.reviews = this.reviews.filter((val) => val.id != review.id);
      });
    },
    goToNextSlide() {
      this.$refs.carousel.goToNext()
    },
    goToPrevSlide() {
      this.$refs.carousel.goToPrev()
    },
    writeToMaster() {
      if (this.isUserAuth) {
        this.createConversation(this.$route.params.id);
      } else {
        this.openModal('auth_to_sign_up')
      }
    },
    callToMaster() {
      window.location.href = `tel:${this.master.phone}`;
    }
  },
  beforeDestroy() {
    this.$eventHub.$off('review.create');
  },
}

</script>

<style lang="scss">
h3 {
  margin-bottom: 0;
}

.carouselWrap {
  width: calc(100% + 30px);
  margin-left: -10px;
}

.specbtn {
  border: none;
  background-color: transparent;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  color: #B9765B;
}

.flex__top {
  margin-bottom: 35px;
  display: flex;
}

@media screen and (max-width: 991px) {
  h1.infoPage {
    font-weight: 600;
    font-size: 24px;
    line-height: 1.3;
    color: #383838;
  }
  .flex__top {
    flex-direction: column;
  }
  .infoPage-subtitle {
    font-size: 20px;
  }
}
</style>
